import { render, staticRenderFns } from "./SystemConfigBulletin.vue?vue&type=template&id=21ced84c&"
import script from "./SystemConfigBulletin.vue?vue&type=script&lang=js&"
export * from "./SystemConfigBulletin.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigBulletin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports